<template>
	<div class="point">
		<div class="point-number">{{ number }}</div>
		<vue-markdown class="point-text">{{ point }}</vue-markdown>
	</div>
</template>

<script>
	import VueMarkdown from 'vue-markdown';

	export default {
		name: 'point',
		props: {
			number: {
				type: Number,
				required: true
			},
			point: {
				type: String,
				required: true
			}
		},
		components: {
			VueMarkdown
		}
	}
</script>

<style lang="less">
	@import "~@less/font-sizes.less";

	.point {
		@ballSize: 40px;

		margin-bottom: 20px;
		flex-wrap: nowrap !important;

		.point-number {
			width: @ballSize;
			height: @ballSize;
			min-width: @ballSize;
			min-height: @ballSize;

			background: black;
			color: white;
			font-size: @ballSize * .8;
			font-weight: bold;
			border-radius: @ballSize / 2;
			text-align: center;
			line-height: @ballSize * .8;
		}

		.point-text {
			padding-left: 10px;
			font-size: @app-font-size-point;
			font-weight: bold;
			align-self: center;
		}
	}
</style>